// Translations for PortalFinca — ES (default) and CA
export const translations = {
  es: {
    nav: {
      product: 'Producto',
      howItWorks: 'Cómo funciona',
      pricing: 'Precios',
      faq: 'FAQ',
      demo: 'Ver demo',
      cta: 'Solicitar demo',
    },
    hero: {
      eyebrow: 'Para administradores de fincas',
      title1: 'Menos ruido.',
      title2: 'Más comunidad.',
      subtitle:
        'La capa operativa que tu despacho necesita. Complementa tu ERP con gestión ágil de incidencias, avisos y portal del presidente — sin reemplazar nada.',
      ctaPrimary: 'Solicitar demo',
      ctaSecondary: 'Ver cómo funciona',
      stat1: 'incidencias gestionadas sin llamadas',
      stat2: 'menos correos repetitivos',
      stat3: 'presidentes informados al día',
    },
    problem: {
      eyebrow: 'El problema',
      title: '3 llamadas, 5 WhatsApps y 1 email para una bombilla rota.',
      body:
        'La comunicación en un despacho de fincas vive dispersa entre teléfonos, grupos de WhatsApp, correos y notas en papel. Cada incidencia se cuenta tres veces, los presidentes piden estados a deshora, y los vecinos repiten el mismo problema porque nadie les confirmó nada.',
      points: [
        'Información que no queda registrada',
        'Presidentes pidiendo el mismo informe semana tras semana',
        'Tiempo perdido reexplicando incidencias ya resueltas',
      ],
    },
    solution: {
      eyebrow: 'La solución',
      title: 'Una capa ligera. Tres pilares claros.',
      subtitle: 'No reemplazamos tu ERP. Lo complementamos donde más duele.',
      pillars: [
        {
          title: 'Incidencias',
          desc: 'El vecino escanea un QR, sube una foto y categoriza. El despacho recibe, asigna y resuelve. Todo queda trazado.',
        },
        {
          title: 'Avisos',
          desc: 'Comunica por edificio o portal. Cortes de agua, juntas, obras — sin abrir 12 grupos de WhatsApp.',
        },
        {
          title: 'Portal del presidente',
          desc: 'Vista de solo lectura con incidencias, avisos y documentos. El presidente deja de llamar.',
        },
      ],
    },
    how: {
      eyebrow: 'Cómo funciona',
      title: 'Tres pasos. Listo.',
      steps: [
        { n: '01', t: 'Escanea el QR', d: 'Cada portal tiene su QR físico o digital. Sin app, sin login complicado.' },
        { n: '02', t: 'Reporta con foto', d: 'Vivienda, categoría, descripción y foto opcional. 30 segundos.' },
        { n: '03', t: 'El despacho gestiona', d: 'Asigna, comenta, cambia estado. El vecino y el presidente lo ven.' },
      ],
    },
    features: {
      eyebrow: 'Funcionalidades',
      title: 'Construido para despachos que quieren orden, no software.',
      items: [
        { t: 'Trazabilidad total', d: 'Cada incidencia, con histórico, foto y responsable.' },
        { t: 'Repositorio de documentos', d: 'Actas, normas, contratos, pólizas — por comunidad.' },
        { t: 'Filtros multi-comunidad', d: 'Ve solo lo urgente, solo una calle, solo lo abierto.' },
        { t: 'Roles y permisos', d: 'Administrador, presidente, vecino, proveedor. Cada uno ve lo suyo.' },
        { t: 'Histórico exportable', d: 'CSV / PDF para juntas. Sin reescribir nada.' },
        { t: 'Onboarding en horas', d: 'Sin migración compleja. Empieza con una comunidad.' },
      ],
    },
    target: {
      eyebrow: 'Para quién',
      title: 'Pensado para despachos de 20 a 100 comunidades.',
      body:
        'Si tienes entre 2 y 15 personas, sin departamento técnico, y la comunicación con vecinos te quita más horas que la contabilidad — PortalFinca es para ti.',
    },
    pricing: {
      eyebrow: 'Precios',
      title: 'Pagas por comunidades activas. Sin sorpresas.',
      subtitle: 'Todos los planes incluyen incidencias, avisos, documentos y portal del presidente.',
      monthly: '/ mes',
      perCommunity: 'por comunidad extra',
      cta: 'Empezar',
      mostPopular: 'Más elegido',
      plans: [
        {
          name: 'Starter',
          price: '49 €',
          unit: '/ mes',
          desc: 'Hasta 10 comunidades',
          extra: '5 € por comunidad extra',
          features: ['Incidencias ilimitadas', 'Portal presidente', 'Avisos por comunidad', 'Soporte por email'],
        },
        {
          name: 'Pro',
          price: '149 €',
          unit: '/ mes',
          desc: 'Hasta 30 comunidades',
          extra: '4 € por comunidad extra',
          features: ['Todo lo de Starter', 'Repositorio de documentos', 'Roles avanzados', 'Soporte prioritario'],
        },
        {
          name: 'Business',
          price: '349 €',
          unit: '/ mes',
          desc: 'Hasta 100 comunidades',
          extra: '3 € por comunidad extra',
          features: ['Todo lo de Pro', 'Reportes y exportaciones', 'Onboarding asistido', 'Account manager dedicado'],
        },
      ],
    },
    leadForm: {
      eyebrow: 'Solicita tu demo',
      title: 'Te enseñamos cómo encaja en 20 minutos.',
      subtitle: 'Demo personalizada, sin compromiso. Te respondemos en menos de 24 h laborables.',
      fields: {
        name: 'Nombre y apellidos',
        email: 'Email profesional',
        company: 'Nombre del despacho',
        communities: 'Nº de comunidades',
        phone: 'Teléfono (opcional)',
        message: 'Cuéntanos brevemente qué buscas (opcional)',
      },
      communitiesOptions: ['1 - 10', '11 - 30', '31 - 60', '61 - 100', 'Más de 100'],
      submit: 'Solicitar demo',
      submitting: 'Enviando…',
      successTitle: '¡Solicitud recibida!',
      successBody: 'Te contactaremos en menos de 24 horas laborables.',
      error: 'No se pudo enviar. Revisa los datos e inténtalo de nuevo.',
      privacy: 'Tus datos están seguros. RGPD compliant. Nunca compartimos información con terceros.',
    },
    faq: {
      eyebrow: 'Dudas frecuentes',
      title: 'Lo que más nos preguntáis.',
      items: [
        {
          q: '¿Sustituye a mi ERP de contabilidad?',
          a: 'No. PortalFinca es una capa complementaria. Tu Gesfincas, TAAF, Fincas Plus o el que uses sigue donde está. Nosotros nos encargamos de la comunicación operativa.',
        },
        {
          q: '¿Necesitan los vecinos descargar una app?',
          a: 'No. Funciona por QR + enlace web. Sin descargas, sin registros complicados. Compatible con cualquier móvil moderno.',
        },
        {
          q: '¿Y la protección de datos?',
          a: 'Cumplimos RGPD. Alojamiento en la UE, cifrado en tránsito y en reposo, DPA firmable y políticas de retención claras.',
        },
        {
          q: '¿Cuánto tardamos en arrancar?',
          a: 'Una comunidad puede estar operativa en menos de un día. El despacho completo, en 1-2 semanas según volumen.',
        },
        {
          q: '¿Puedo probarlo sin pagar?',
          a: 'Sí. Ofrecemos un piloto de 30 días con 3 comunidades para validar el encaje. Sin tarjeta de crédito.',
        },
      ],
    },
    finalCta: {
      title: 'Reduce el ruido. Empieza esta semana.',
      subtitle: 'Una demo de 20 minutos vale por mil emails explicativos.',
      cta: 'Solicitar demo ahora',
    },
    footer: {
      tagline: 'Menos ruido. Más comunidad.',
      product: 'Producto',
      links: ['Funcionalidades', 'Precios', 'Demo', 'FAQ'],
      company: 'Empresa',
      companyLinks: ['Sobre nosotros', 'Blog', 'Contacto'],
      legal: 'Legal',
      legalLinks: ['Aviso legal', 'Privacidad', 'Cookies', 'RGPD'],
      copy: '© 2026 PortalFinca. Hecho en España.',
    },
    demo: {
      back: 'Volver',
      pickPersona: 'Elige una perspectiva',
      pickPersonaSub: 'Explora PortalFinca desde los ojos de cada usuario.',
      personaVecino: 'Vecino',
      personaVecinoDesc: 'Reporta una incidencia desde el móvil con un QR.',
      personaAdmin: 'Administrador',
      personaAdminDesc: 'Gestiona incidencias, avisos y comunidades.',
      personaPresidente: 'Presidente',
      personaPresidenteDesc: 'Consulta el estado de tu comunidad en modo solo lectura.',
      mockBadge: 'Demo interactiva — datos de ejemplo',
      restart: 'Reiniciar demo',
    },
  },
  ca: {
    nav: {
      product: 'Producte',
      howItWorks: 'Com funciona',
      pricing: 'Preus',
      faq: 'FAQ',
      demo: 'Veure demo',
      cta: 'Sol·licitar demo',
    },
    hero: {
      eyebrow: 'Per a administradors de finques',
      title1: 'Menys soroll.',
      title2: 'Més comunitat.',
      subtitle:
        "La capa operativa que el teu despatx necessita. Complementa el teu ERP amb gestió àgil d'incidències, avisos i portal del president — sense substituir res.",
      ctaPrimary: 'Sol·licitar demo',
      ctaSecondary: 'Veure com funciona',
      stat1: 'incidències gestionades sense trucades',
      stat2: 'menys correus repetitius',
      stat3: 'presidents informats al dia',
    },
    problem: {
      eyebrow: 'El problema',
      title: '3 trucades, 5 WhatsApps i 1 correu per una bombeta trencada.',
      body:
        "La comunicació en un despatx de finques viu dispersa entre telèfons, grups de WhatsApp, correus i notes en paper. Cada incidència s'explica tres vegades, els presidents demanen estats a deshora, i els veïns repeteixen el mateix problema perquè ningú els va confirmar res.",
      points: [
        'Informació que no queda registrada',
        'Presidents demanant el mateix informe setmana rere setmana',
        "Temps perdut reexplicant incidències ja resoltes",
      ],
    },
    solution: {
      eyebrow: 'La solució',
      title: 'Una capa lleugera. Tres pilars clars.',
      subtitle: 'No substituïm el teu ERP. El complementem allà on més fa mal.',
      pillars: [
        {
          title: 'Incidències',
          desc: "El veí escaneja un QR, puja una foto i categoritza. El despatx rep, assigna i resol. Tot queda traçat.",
        },
        {
          title: 'Avisos',
          desc: "Comunica per edifici o portal. Talls d'aigua, juntes, obres — sense obrir 12 grups de WhatsApp.",
        },
        {
          title: 'Portal del president',
          desc: 'Vista de només lectura amb incidències, avisos i documents. El president deixa de trucar.',
        },
      ],
    },
    how: {
      eyebrow: 'Com funciona',
      title: 'Tres passos. Llest.',
      steps: [
        { n: '01', t: 'Escaneja el QR', d: 'Cada portal té el seu QR físic o digital. Sense app, sense login complicat.' },
        { n: '02', t: 'Reporta amb foto', d: 'Habitatge, categoria, descripció i foto opcional. 30 segons.' },
        { n: '03', t: 'El despatx gestiona', d: 'Assigna, comenta, canvia estat. El veí i el president ho veuen.' },
      ],
    },
    features: {
      eyebrow: 'Funcionalitats',
      title: 'Construït per a despatxos que volen ordre, no programari.',
      items: [
        { t: 'Traçabilitat total', d: 'Cada incidència, amb històric, foto i responsable.' },
        { t: 'Repositori de documents', d: 'Actes, normes, contractes, pòlisses — per comunitat.' },
        { t: 'Filtres multi-comunitat', d: 'Veu només el que és urgent, només un carrer, només el que està obert.' },
        { t: 'Rols i permisos', d: 'Administrador, president, veí, proveïdor. Cadascú veu el seu.' },
        { t: 'Històric exportable', d: 'CSV / PDF per a juntes. Sense reescriure res.' },
        { t: 'Onboarding en hores', d: "Sense migració complexa. Comença amb una comunitat." },
      ],
    },
    target: {
      eyebrow: 'Per a qui',
      title: 'Pensat per a despatxos de 20 a 100 comunitats.',
      body:
        'Si tens entre 2 i 15 persones, sense departament tècnic, i la comunicació amb veïns et treu més hores que la comptabilitat — PortalFinca és per a tu.',
    },
    pricing: {
      eyebrow: 'Preus',
      title: 'Pagues per comunitats actives. Sense sorpreses.',
      subtitle: "Tots els plans inclouen incidències, avisos, documents i portal del president.",
      monthly: '/ mes',
      perCommunity: 'per comunitat extra',
      cta: 'Començar',
      mostPopular: 'Més escollit',
      plans: [
        {
          name: 'Starter',
          price: '49 €',
          unit: '/ mes',
          desc: 'Fins a 10 comunitats',
          extra: '5 € per comunitat extra',
          features: ['Incidències il·limitades', 'Portal president', 'Avisos per comunitat', 'Suport per correu'],
        },
        {
          name: 'Pro',
          price: '149 €',
          unit: '/ mes',
          desc: 'Fins a 30 comunitats',
          extra: '4 € per comunitat extra',
          features: ['Tot el de Starter', 'Repositori de documents', 'Rols avançats', 'Suport prioritari'],
        },
        {
          name: 'Business',
          price: '349 €',
          unit: '/ mes',
          desc: 'Fins a 100 comunitats',
          extra: '3 € per comunitat extra',
          features: ['Tot el de Pro', 'Informes i exportacions', 'Onboarding assistit', 'Account manager dedicat'],
        },
      ],
    },
    leadForm: {
      eyebrow: 'Sol·licita la teva demo',
      title: 'Et mostrem com encaixa en 20 minuts.',
      subtitle: 'Demo personalitzada, sense compromís. Et responem en menys de 24 h laborables.',
      fields: {
        name: 'Nom i cognoms',
        email: 'Correu professional',
        company: 'Nom del despatx',
        communities: 'Nº de comunitats',
        phone: 'Telèfon (opcional)',
        message: 'Explica breument què busques (opcional)',
      },
      communitiesOptions: ['1 - 10', '11 - 30', '31 - 60', '61 - 100', 'Més de 100'],
      submit: 'Sol·licitar demo',
      submitting: 'Enviant…',
      successTitle: 'Sol·licitud rebuda!',
      successBody: 'Et contactarem en menys de 24 hores laborables.',
      error: "No s'ha pogut enviar. Revisa les dades i torna-ho a provar.",
      privacy: 'Les teves dades estan segures. Compleix RGPD. Mai compartim informació amb tercers.',
    },
    faq: {
      eyebrow: 'Dubtes freqüents',
      title: 'El que més ens pregunteu.',
      items: [
        {
          q: 'Substitueix el meu ERP de comptabilitat?',
          a: 'No. PortalFinca és una capa complementària. El teu Gesfincas, TAAF o el que utilitzis continua on és. Nosaltres ens encarreguem de la comunicació operativa.',
        },
        {
          q: "Cal que els veïns descarreguin una app?",
          a: 'No. Funciona per QR + enllaç web. Sense descàrregues, sense registres complicats.',
        },
        {
          q: 'I la protecció de dades?',
          a: 'Complim el RGPD. Allotjament a la UE, xifrat en trànsit i en repòs, DPA signable.',
        },
        {
          q: 'Quant trigarem a arrencar?',
          a: 'Una comunitat pot estar operativa en menys d’un dia. El despatx complet, en 1-2 setmanes.',
        },
        {
          q: 'Puc provar-ho sense pagar?',
          a: 'Sí. Oferim un pilot de 30 dies amb 3 comunitats per validar l’encaix. Sense targeta de crèdit.',
        },
      ],
    },
    finalCta: {
      title: 'Redueix el soroll. Comença aquesta setmana.',
      subtitle: 'Una demo de 20 minuts val per mil correus explicatius.',
      cta: 'Sol·licitar demo ara',
    },
    footer: {
      tagline: 'Menys soroll. Més comunitat.',
      product: 'Producte',
      links: ['Funcionalitats', 'Preus', 'Demo', 'FAQ'],
      company: 'Empresa',
      companyLinks: ['Sobre nosaltres', 'Blog', 'Contacte'],
      legal: 'Legal',
      legalLinks: ['Avís legal', 'Privacitat', 'Cookies', 'RGPD'],
      copy: '© 2026 PortalFinca. Fet a Espanya.',
    },
    demo: {
      back: 'Tornar',
      pickPersona: 'Tria una perspectiva',
      pickPersonaSub: 'Explora PortalFinca des dels ulls de cada usuari.',
      personaVecino: 'Veí',
      personaVecinoDesc: 'Reporta una incidència des del mòbil amb un QR.',
      personaAdmin: 'Administrador',
      personaAdminDesc: 'Gestiona incidències, avisos i comunitats.',
      personaPresidente: 'President',
      personaPresidenteDesc: 'Consulta l’estat de la teva comunitat en mode només lectura.',
      mockBadge: 'Demo interactiva — dades d’exemple',
      restart: 'Reiniciar demo',
    },
  },
};
